<script setup lang="ts">
  import type { ILegend } from '@/components/fsf/calendar/types'

  const legends: ILegend[] = [
    {
      title: 'fsf.calendar.legends.direct',
      key: 'direct',
      icon: 'common/round-airplane-90-deg',
      iconColor: 'text-bt-dark-blue',
      iconSize: 'sm'
    },
    {
      title: 'fsf.calendar.legends.inactive',
      key: 'inactive',
      icon: 'fsf/airplane-inactive',
      iconColor: 'text-border',
      iconSize: 'sm'
    },
    {
      title: 'fsf.calendar.legends.price',
      key: 'euro-price',
      icon: 'common/load-euro',
      iconColor: 'text-secondary',
      iconSize: 'ml'
    }
  ]
</script>

<template>
  <div
    class="flex w-full gap-6 overflow-x-auto px-4 py-3 md:overflow-y-hidden md:p-0"
    aria-hidden="true"
  >
    <div
      v-for="legend in legends"
      :key="legend.key"
      class="flex flex-shrink-0 flex-grow items-center gap-2 sm:grow-0"
    >
      <div
        class="md:flex md:size-6 md:items-center md:justify-center"
        :class="legend.iconColor"
      >
        <Icon
          :name="legend.icon"
          :size="legend.iconSize"
        />
      </div>
      <span class="text-body-2">{{ $t(legend.title) }}</span>
    </div>
  </div>
</template>
